export function currencyFormat(val: any) {
  if (val == undefined) {
    return;
  }
  val = val.toString().replaceAll(",", "");
  val = parseFloat(val);
  var is_nagetive = val < 0 ? true : false;
  var num = is_nagetive ? -1*val : val;
  return (is_nagetive ? '-':'') + '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}